module.exports = __webpack_public_path__ + "static/img/Rectangle 2@2x.c3fd09b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/Rectangle 2@2x.png
// module id = gcGP
// module chunks = 1